import React, { FocusEvent, useContext, useState } from 'react';
import { DatePicker, DateView } from '@mui/x-date-pickers';
import { SELECT_DATE } from 'common/constants/inputs';
import withTooltip from 'components/WithTooltip';
import LedgerContext from 'context/LedgerContext';
import { gridShortDate } from 'utilities/dateFormats';
import { DateInputProps } from './DateInput.props';

const DateInput = ({ cell, minDate = undefined }: DateInputProps) => {
  const { onCellsChange } = useContext(LedgerContext);
  const [date, setDate] = useState(cell.value);

  const handleChange = (date: moment.MomentInput) => {
    if (date) {
      setDate(gridShortDate(date));
    }
  };

  const handleAccept = (date: moment.MomentInput) => {
    onCellsChange([{ cell, value: gridShortDate(date) }]);
  };

  const handleFocus = () => {
    if (!cell.value) {
      setDate(gridShortDate(minDate || date));
    }
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    handleAccept(event.target.value);
  };

  return (
    <DatePicker
      value={date as Date}
      format="MM/dd/yyyy"
      onChange={handleChange}
      onAccept={handleAccept}
      // onFocus={handleFocus}
      // onBlur={handleBlur}
      openTo={cell.value ? 'day' : 'year'}
      views={['year', 'month', 'day']}
      disabled={!!cell.readOnly}
      // InputProps={{ disableUnderline: true }}
      // KeyboardButtonProps={{ 'aria-label': 'change date' }}
      className="ledger-table-date-picker"
      minDate={minDate ? new Date(minDate) : undefined}
      {...(cell.isRequired ? { emptyLabel: SELECT_DATE } : {})}
      {...(!cell.value ? { helperText: '' } : {})}
    />
  );
};

export default withTooltip(DateInput);
